import '../../App.css';
import React, { useContext, useEffect, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral';
import Footer from '../../components/footer/Footer';
import { FaPlus, FaSearch } from 'react-icons/fa';
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarCobertura from '../../components/modal/ModalCadastrarCobertura';
import ModalEditarCobertura from '../../components/modal/ModalEditarCobertura';
import ModalExcluirCobertura from '../../components/modal/ModalExcluirCobertura';
import { ServicoContext } from '../../context/ServicoContext';
import Tabela from '../../components/Tabela';

function Cobertura() {
    const { Success, Error, openModal, setOpenModal, CoberturasConsulta, ListaCoberturaConsulta, loading, modalEditarCobertura, setModalEditarCobertura, setEdicaoCobertura, setCoberturaAtualKey, modalExcluirCobertura, setModalExcluirCobertura, InativarCobertura, ListaFiltroCobertura, totalRegistrosCobertura, filtroCobertura, totalRegistrosFiltroCobertura } = useContext(ServicoContext);

    const { Permissao } = useContext(ApiContext);
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditCobertura = (props) => {
        setModalEditarCobertura(true);
        setCoberturaAtualKey(props.key);
        setEdicaoCobertura(props);
    };

    const DeletarCobertura = (props) => {
        setCoberturaAtualKey(props.key);
        setModalExcluirCobertura(true);
    };

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroCobertura(searchTerm, currentPage, pageSize);
        } else {
            ListaCoberturaConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroCobertura : totalRegistrosCobertura;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar coberturas'} />
            <MenuLateral />

            {modalEditarCobertura && <ModalEditarCobertura currentPage={currentPage} />}
            {modalExcluirCobertura && <ModalExcluirCobertura currentPage={currentPage} />}
            {openModal && <ModalCadastrarCobertura closeModal={setOpenModal} currentPage={currentPage} />}

            {Success && (
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            )}
            {Error && (
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            )}

            <div className='container-principal'>
                <div className='demanda-header'>
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) && (
                        <button
                            className='btn-dash btn-criar'
                            style={btnCriar}
                            onClick={() => setOpenModal(true)}
                        >
                            <FaPlus style={{ marginRight: "10px" }} />Cadastrar cobertura
                        </button>
                    )}
                </div>

                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Coberturas cadastradas</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroCobertura : CoberturasConsulta}
                        columns={[
                            { label: "Cobertura", field: "nome", width: "40%" },
                            { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                            {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarCobertura(x.key, !x.ativo)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditCobertura(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarCobertura(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroCobertura(term, 1, 10);
                            } else {
                                ListaCoberturaConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />

                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Cobertura;
